import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import * as React from 'react';
import PropTypes from 'prop-types';
import { sizes, sizeMap, useId } from './utils';

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.253 5.108c-1.927-1.689-4.792-1.385-6.56.491L12 6.334l-.692-.735c-1.765-1.876-4.634-2.18-6.56-.491-2.208 1.938-2.324 5.417-.348 7.517l6.802 7.225c.44.467 1.153.467 1.593 0l6.802-7.225c1.98-2.1 1.864-5.58-.344-7.517z"
});

function HeartSolid(_ref) {
  let {
    size: sizeProp,
    title,
    titleId
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["size", "title", "titleId"]);

  const size = sizeMap.get(sizeProp);
  titleId = useId(titleId);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size.width,
    height: size.height,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#212429",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

HeartSolid.sizes = sizes;
HeartSolid.defaultProps = {
  size: sizes.md
};
HeartSolid.propTypes = {
  size: PropTypes.oneOf([HeartSolid.sizes.xs, HeartSolid.sizes.sm, HeartSolid.sizes.md, HeartSolid.sizes.lg, HeartSolid.sizes.xl]),
  titleId: PropTypes.string,
  title: PropTypes.string.isRequired
};
export default HeartSolid;